



















import Vue from 'vue'
import { SORT_ORDER } from '@/search/const'

export default Vue.extend({
  props: {
    selectedSortOrder:{
      type: String,
      required: true
    }
  },
  data(): {
    selectedOrder: string
    sortOrderItems: Array<{ [key: string]: string }>
  } {
    return {
      sortOrderItems: SORT_ORDER,
      selectedOrder: this.selectedSortOrder
    }
  }
})
